import React, { ReactNode } from 'react';

export default function PaginationItem({ children }: { children: ReactNode }): JSX.Element {
  return <li className="usa-pagination__item usa-pagination__no">{children}</li>;
}
